import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { addGeneratedContent } from './commands/addGeneratedContent'
import { getContent } from './commands/getContent'
import { getSelection } from './commands/getSelection'
import { removeSelection } from './commands/removeSelection'
import { GeneratedContentLeaf } from './nodes/GeneratedContentLeaf'

/**
 *
 */
const onSelectionCheck = (editor: BufferEditor): void => {
  editor.onSelectionCheckCallback?.()
}

/**
 * Not returned directly from the arrow function: an explicit return type on
 * the expression itself back-propagates into createPlatePlugin's own
 * generic inference and corrupts it (options/node end up typed against the
 * annotation's defaults instead of the literal passed in).
 */
const createContentGenerationPlugin = (): AnyPlatePlugin => {
  const plugin = createPlatePlugin({
    key: 'shouldAnimateGeneration',
    node: {
      isLeaf: true,
      component: GeneratedContentLeaf,
    },
    extendEditor: ({ editor: rawEditor }) => {
      const editor = rawEditor as unknown as BufferEditor

      editor.addGeneratedContent = ({ content }: { content: string }): void => {
        addGeneratedContent({ editor, content })
        removeSelection({ editor })
      }

      editor.getContent = (): string => {
        return getContent({ editor })
      }

      editor.getSelection = (): string | null => {
        return getSelection({ editor })
      }

      editor.removeSelection = (): void => {
        removeSelection({ editor })
      }

      editor.onSelectionCheckCallback = null
      editor.onSelectionCheck = (callback: () => void): void => {
        editor.onSelectionCheckCallback = callback
      }

      return editor
    },

    handlers: {
      onChange: ({ editor }): void => {
        onSelectionCheck(editor as unknown as BufferEditor)
      },
      onFocus: ({ editor }): void => {
        onSelectionCheck(editor as unknown as BufferEditor)
      },
    },
  })
  return plugin
}

export { createContentGenerationPlugin }
